<template>
    <router-view/>
</template>

<script>
    export default {
        name: "Admin",
        components: {},
        data() {
            return {};
        },
    };
</script>

<style lang="scss">
</style>

